import moment from "moment";

export const normalizeQueryString = (queryText = "") => {
  if (!queryText || queryText === "?") {
    return "";
  }

  return queryText.startsWith("?") ? queryText.substring(1) : queryText;
};

export const combineQueryStrings = (...queries) => {
  const params = new URLSearchParams();

  queries.forEach((queryText) => {
    const normalized = normalizeQueryString(queryText);
    if (!normalized) {
      return;
    }

    const queryParams = new URLSearchParams(normalized);
    queryParams.forEach((value, key) => {
      if (value !== "") {
        params.set(key, value);
      }
    });
  });

  const query = params.toString();
  return query ? `?${query}` : "";
};

export const parseTableFilterDate = (rawValue) => {
  const value = String(rawValue || "").trim();
  const parsedDate = moment(
    value,
    ["DD MMM YYYY", "DD MMMM YYYY", "DD-MMM-YYYY", "DD-MM-YYYY", "DD/MM/YYYY", "YYYY-MM-DD", "YYYY/MM/DD", "MM-DD-YYYY"],
    true
  );

  return parsedDate.isValid() ? parsedDate.format("DD-MM-YYYY") : "";
};

export const parseTableFilterNumber = (rawValue) => {
  const value = String(rawValue || "").trim().replace(/\s/g, "");

  if (!value) {
    return "";
  }

  const hasComma = value.includes(",");
  const hasDot = value.includes(".");
  let normalized = value;

  if (hasComma && hasDot) {
    normalized = value.replace(/\./g, "").replace(",", ".");
  } else if (hasComma) {
    normalized = value.replace(",", ".");
  } else if (hasDot) {
    const dotParts = value.split(".");
    const lastPart = dotParts[dotParts.length - 1];
    normalized = dotParts.length > 2 || lastPart.length === 3 ? value.replace(/\./g, "") : value;
  }

  return /^-?\d+(\.\d+)?$/.test(normalized) ? normalized : "";
};

export const normalizeTableFilterOperator = (rawOperator) => {
  if (!rawOperator) {
    return "contains";
  }

  return String(rawOperator)
    .trim()
    .replace(/\s/g, "")
    .toLowerCase();
};

export const buildTableFilterQuery = (filterModel, fieldMap) => {
  const params = new URLSearchParams();
  const items = Array.isArray(filterModel?.items) ? filterModel.items : [];

  items.forEach((item) => {
    const field = item.columnField || item.field;
    const config = fieldMap[field];
    const rawValue = Array.isArray(item.value) ? item.value[0] : item.value;
    const rawOperator = item.operatorValue || item.operator;

    if (!config || rawValue === null || rawValue === undefined || rawValue === "") {
      return;
    }

    const entry = typeof config === "string" ? { queryField: config } : config;

    if (entry.type === "date") {
      const formattedDate = parseTableFilterDate(rawValue);
      if (formattedDate) {
        params.set(entry.startField, formattedDate);
        params.set(entry.endField, formattedDate);
      }
      return;
    }

    if (entry.type === "number") {
      const formattedNumber = parseTableFilterNumber(rawValue);
      if (formattedNumber) {
        params.set(entry.queryField, formattedNumber);
      }
      return;
    }

    const transformedValue = entry.transform
      ? entry.transform(rawValue)
      : String(rawValue).trim();

    if (transformedValue === null || transformedValue === undefined || transformedValue === "") {
      return;
    }

    params.set(entry.queryField, transformedValue);
    if (entry.includeOperator) {
      params.set(`${entry.queryField}Operator`, normalizeTableFilterOperator(rawOperator));
    }
  });

  const query = params.toString();
  return query ? `?${query}` : "";
};
